import { render, staticRenderFns } from "./DeliveryFilterForm.vue?vue&type=template&id=4e87e0a4"
import script from "./DeliveryFilterForm.vue?vue&type=script&lang=js"
export * from "./DeliveryFilterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports